export const API_VERSION = "/api/v1/";

export const ACTION = {
  CREATE: "create",
  EDIT: "edit",
  DOWNLOAD: "download"
};

export const STATUS = {
  PENDING: "Pending",
  APPROVED: "Approve",
  REJECTED: "Reject",
  FINISHED: "Finished",
  SKIPPED: "Skipped"
};

export const HHCONTRACTSTATUSENUMTYPE = {
  APPROVED: "Approved",
  PENDING: "Pending",
  REJECTED: "Rejected",
  SENDFORREVIEW: "SendForReview",
};

export const ROLE = {
  ADMIN: "Admin",
  MARKEL: "Markel",
  CLIENT: "Client",
  MANAGER: "Manager",
  DEV: "Developer"
};

export const MOVEELEMENT = {
  UP: "up",
  DOWN: "down",
};

export const USERROLE = {
  ADMIN: "Admin",
  MARKEL: "Markel",
  CLIENT: "Client",
  SUBCONTRACTOR: "Subcontractor",
};

export const SIGNCONTRACTSTATUS = {
  SIGNED: "Signed",
  CONTRACTSENT: "Contract Sent",
};

export const TRACKCHANGE={
  NAME:"trackChanges",
  ACTION:{
    CREATED:"Created",
    APPROVED:"approved",
    REJECTED:"rejected"

  },
  CHANGETYPE:{
    ADDED:"added",
    DELETED:"deleted",
    MODIFIED:"modified"
  },
  VISIBILITYFOR:{
    ADMIN:"Admin",
    MARKEL:"Markel",
    CLIENT:"Client",
    SUBCONTRACTOR:"Subcontractor"
  },
  HIDDENTYPE:{
    EMPTY:" ",
    TRUE:"true",
    FALSE:"false"
  },
  COMMENTSTATUS:{
    ACCEPTED:"accepted",
    REJECTED:"rejected",
  }
}
